import { SportDataGateway } from "sb-resp-lib";
import { countMapper, SportsMapper } from "../../mapper";
import { Observer, EntityPushPayload, entities } from "sbtech-sports-data-api-client";
import { SportApiQueryFactory } from "../../queries";
import { IState } from "../../../../common";
import { SportModel } from "../..";

export class SportPushesRetriever {

    private sportsSubscription: Observer;
    private readonly sportsMapper: SportsMapper;
    private readonly countMapper: countMapper;
    private readonly sportDataGateway: SportDataGateway;

    constructor(sportsMapper: SportsMapper, countMapper: countMapper, sportDataGateway: SportDataGateway) {
        this.sportsMapper = sportsMapper;
        this.countMapper = countMapper;
        this.sportDataGateway = sportDataGateway;
        this.sportsSubscription = { unsubscribe:() => {} };
    }

    subscribe(state: IState<SportModel>, queryFactory: SportApiQueryFactory) {
        const queryInfo = queryFactory((message) => this.updateSports(state, message.data));
        this.sportsSubscription = this.sportDataGateway.subscribeForSports(queryInfo);
    }

    unsubscribe() {
        this.sportsSubscription.unsubscribe();
    }

    private updateSports(state: IState<SportModel>, data: EntityPushPayload<entities.Sport, entities.SportChange>) {
        if (data.add.length > 0) {
            const added = this.sportsMapper.mapFromPushes(data.add);
            state.replaceItems(state.Items.concat(added));
        }
        if (data.remove.length > 0) {
            data.remove.forEach(id => state.remove(id));
        }
        if (data.change.length > 0) {
            data.change.forEach(c => this.updateSportInState(state, c));
        }
    }

    private updateSportInState(state: IState<SportModel>, sportChange: entities.SportChange) {
        const numberOfEvents = this.countMapper(sportChange);
        if (numberOfEvents > 0) {
            state.update(sportChange.id, {numberOfEvents});
        } else {
            state.remove(sportChange.id);
        }
    }
}